import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppURL } from './app.url';
import { UiComponent } from './shareds/ui/ui.component';
import { SettingComponent } from './pages/setting/setting.component';
import { CheckComponent } from './pages/check/check.component';
import { ApiComponent } from './pages/api/api.component';
import { KeyapiComponent } from './pages/keyapi/keyapi.component';
import { RankComponent } from './pages/rank/rank.component';
import { MemberComponent } from './pages/member/member.component';
import { RateComponent } from './pages/rate/rate.component';
import { PointComponent } from './pages/point/point.component';
import { EventComponent } from './pages/event/event.component';
import { RewardsComponent } from './pages/rewards/rewards.component';
import { GiftVoucherComponent } from './pages/gift-voucher/gift-voucher.component';
import { SecretComponent } from './pages/secret/secret.component';
import { ServerIpComponent } from './pages/server-ip/server-ip.component';
import { TransactionComponent } from './pages/transaction/transaction.component';
import { RedeemComponent } from './pages/redeem/redeem.component';
import { ItemRewardBoxComponent } from './pages/item-reward-box/item-reward-box.component';
import { SettingMarketComponent } from './pages/setting-market/setting-market.component';
import { CodeUsedComponent } from './pages/code-used/code-used.component';
import { CouponComponent } from './pages/coupon/coupon.component';
import { SendGiftVoucherComponent } from './pages/gift-voucher/send-gift-voucher/send-gift-voucher.component';
import { DeductComponent } from './pages/deduct/deduct.component';
import { GetLinkComponent } from './pages/get-link/get-link.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';




const routes: Routes = [
  { path: '', redirectTo: AppURL.check, pathMatch: 'full' },
  {
    path: AppURL.check, children: [
      { path: '', component: CheckComponent },
    ]
  },
  {
    path: AppURL.setting, children: [
      { path: '', component: SettingComponent },
    ]
  },
  {
    path: AppURL.rank, children: [
      { path: '', component: RankComponent },
    ]
  },
  {
    path: AppURL.member, children: [
      { path: '', component: MemberComponent },
    ]
  },
  {
    path: AppURL.redeem, children: [
      { path: '', component: RedeemComponent },
    ]
  },
  {
    path: AppURL.itemRewardBox, children: [
      { path: '', component: ItemRewardBoxComponent },
    ]
  },
  {
    path: AppURL.secret, children: [
      { path: '', component: SecretComponent },
    ]
  },
  {
    path: AppURL.transaction, children: [
      { path: '', component: TransactionComponent },
    ]
  },
  {
    path: AppURL.serverip, children: [
      { path: '', component: ServerIpComponent },
    ]
  },
  {
    path: AppURL.codeUsed, children: [
      { path: '', component: CodeUsedComponent },
    ]
  },
  {
    path: AppURL.coupon, children: [
      { path: '', component: CouponComponent },
    ]
  },
  {
    path: AppURL.point, children: [
      { path: '', component: PointComponent },
    ]
  },
  {
    path: AppURL.deduct, children: [
      { path: '', component: DeductComponent },
    ]
  },
  {
    path: AppURL.reward, children: [
      { path: '', component: RewardsComponent },
    ]
  },
  {
    path: AppURL.gift, children: [
      { path: '', component: GiftVoucherComponent },
      { path: 'send/:id', component: SendGiftVoucherComponent },
    ]
  },
  {
    path: AppURL.market, children: [
      { path: '', component: SettingMarketComponent },
    ]
  },
  {
    path: AppURL.customerlink, children: [
      { path: '', component: GetLinkComponent },
    ]
  },
  {
    path: AppURL.event, children: [
      { path: '', component: EventComponent },
    ]
  },
  {
    path: AppURL.dashboard, children: [
      { path: '', component: DashboardComponent },
    ]
  },
  {
    path: AppURL.keyapi, children: [
      { path: '', component: KeyapiComponent },
    ]
  },
  {
    path: AppURL.api, children: [
      { path: '', component: ApiComponent },
    ]
  },
  {
    path: AppURL.ui, children: [
      { path: '', component: UiComponent },
    ]
  },

  { path: '**', loadComponent: () => import('./pages/notfound/notfound.component') }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
